import { createBrowserRouter } from "react-router-dom";
import { DashBoard } from "@/pages/Dashboard";
import Login from "@/pages/Login";
import { App, AppContainer } from "@/App";
import { NotFound } from "@/pages/NotFound";
import { UsersPage } from "@/pages/Users";
import { Companies } from "@/pages/Tenants";
import { PageList as ContestsPage } from "@/pages/Contests";
import { PageList as ContestProfitsPage } from "@/pages/ContestProfits";
import { PageList as UnitsPage } from "@/pages/Units";
import { PageList as EstablishmentsPage } from "@/pages/Establishments";
import { PageList as DiscountTypesPage } from "@/pages/DiscountTypes";
import { PageList as ClientsCategoriesPage } from "@/pages/ClientsCategories";
import { PageList as ClientOriginsPage } from "@/pages/ClientOrigins";
import { PageList as SellersPage } from "@/pages/Seller";
import { PageList as StockistsPage } from "@/pages/Stockist";
import { PageList as LoteriasPage } from "@/pages/ProductGroups";
import { PageList as ProductsPage } from "@/pages/Products";
import { PageList as ClientsPage } from "@/pages/Clients";
import { PageList as StocksPage } from "@/pages/Stocks";
import { PageList as UnitsUsersPage } from "@/pages/Units/Users";
import { PageList as DistributionsPage } from "@/pages/Distributions";
import { PageList as RolesPage } from "@/pages/Roles";
import { AddRolePage } from "@/pages/Roles/Add";
import { UpdateRolePage } from "@/pages/Roles/Update";
import { PageList as SalesPage } from "@/pages/Sales";
import { PageList as SalesListPage } from "@/pages/SalesList";
import { PageList as RoutePage } from "@/pages/Route";
import { PageList as InvestigationSalesPage } from "@/pages/InvestigationSales";
import { PageList as ExpenseCategoriesPage } from "@/pages/ExpenseCategories";
import { PageList as ExpenseTypesPage } from "@/pages/ExpenseTypes";
import { PageList as FinancialTransactionsPage } from "@/pages/FinancialTransactions";
import { ReceiptView } from "@/pages/Sales/ReceiptView";
import { PageList as RevenueCategoriesPage } from "@/pages/RevenueCategories";
import { PageList as RevenueTypesPage } from "@/pages/RevenueTypes";
import { PageList as LogsPage } from "@/pages/Logs";
import { PageList as ImpersonationPage } from "@/pages/Impersonation";
// import NotificationsPage from "@/pages/Notifications";
import { PageList as LeadsKanbanPage } from "@/pages/CRM/Kanban";
import { PageList as LeadsListPage } from "@/pages/CRM/LeadsList";
import { PageList as ContestInvestigationSummaryPage } from "@/pages/ContestInvestigationSummary";
import { KanbanSettings } from "@/pages/Leads/KanbanSettings";
import { ClientPurchases } from "@/pages/Sales/ClientPurchases";
import { PageList as CommissionConfigPageList } from "@/pages/CommissionConfig";
import { PageList as CommissionAccompanimentPageList } from "@/pages/CommissionAccompaniment";
import { PageList as BankAccountsPage } from "@/pages/BankAccounts";
import { PageList as ReconciliationFinancePage } from "@/pages/ReconciationFinancialTransaction";
import { PageView as ReconciliationFinanceView } from "@/pages/ReconciationFinancialTransaction/View";
import { PageList as CashFlowPage } from "@/pages/CashFlow";
import { PageList as ReportsPage } from "@/pages/Reports";
import { PageList as DistributionsPending } from "@/pages/Distributions/Pending";
import { PageList as DistributionsSellersPending } from "@/pages/Distributions/SellersPending";
import { PageList as DistributionsSellersReceived } from "@/pages/Distributions/SellersReceived";
import { PageList as UnityDistributionsPage } from "@/pages/UnityDistributions";
import UnityToUnityDistributions from "@/pages/Distributions/UnityToUnity";
import SellerToSellerDistributions from "@/pages/Distributions/SellerToSeller";
import SellerToUnityDistributions from "@/pages/Distributions/SellerToUnity";
import SellerToUnityHistoryPage from "@/pages/Distributions/SellerToUnityHistory";
import DistributionHistory from "@/pages/Distributions/History";
import { PageList as LeftoversPage } from "@/pages/Leftovers";
import { PageList as MarketplacePage } from "@/pages/Marketplace";
import { PageList as DevolutionsPage } from "@/pages/Devolutions";
import { PublicPaymentPage } from "@/pages/PublicPayment";
import { PublicPaymentAdvancePage } from "@/pages/PublicPaymentAdvance";
import { SellersHistoricPage } from "@/pages/SellersHistoric";
import { DistributionHistory as DistributionHistoryNew } from "@/pages/DistributionHistory";
import { PageList as PaymentAdvancesPage } from "@/pages/PaymentAdvances";
import { PageList as ConfigTenantPage } from "@/pages/ConfigTenant";
import { PageList as StocksSellersSummaryPage } from "@/pages/StocksSellersSummary";
import { PageList as GoalsPage } from "@/pages/Goals";
import { PageList as SaleChangeRequestsPage } from "@/pages/SaleChangeRequests";
import { PageList as PreSalesPage } from "@/pages/PreSales";
import { PageList as ServiceScriptsPage } from "@/pages/ServiceScripts";
import { PageList as SedexPage } from "@/pages/Sedex";
import { PageList as WalletOperationsPage } from "@/pages/WalletOperations";
import { PageList as LeadTrackingPage } from "@/pages/LeadTracking";
import { SellerCommissionRulesPage } from "@/pages/SellerCommissionRules";
import { SellerCommissionTrackingPage } from "@/pages/SellerCommissionTracking";
import { PageList as BalanceAdjustmentsPage } from "@/pages/BalanceAdjustments";
import { PageList as SaleNormalizationPage } from "@/pages/SaleNormalization";

export const routers = createBrowserRouter([
  {
    path: "/",
    element: <AppContainer />,
    children: [
      {
        path: "/",
        element: <App />,
        children: [
          {
            path: "/",
            element: <DashBoard />,
          },
          {
            path: "/dashboard",
            element: <DashBoard />,
          },
          // {
          //   path: "/notifications",
          //   element: <NotificationsPage />,
          // },
          {
            path: "/distribuicoes",
            element: <DistributionsPage />,
          },
          {
            path: "/pendentes-distribuicoes",
            element: <DistributionsPending />,
          },
          {
            path: "/pendentes-distribuicoes-vendedores",
            element: <DistributionsSellersPending />,
          },
          {
            path: "/distribuicoes-recebidas",
            element: <DistributionsSellersReceived />,
          },
          {
            path: "/distribuicoes-unidade",
            element: <UnityDistributionsPage />,
          },
          {
            path: "/distribuicoes-entre-unidades",
            element: <UnityToUnityDistributions />,
          },
          {
            path: "/distribuicoes-entre-vendedores",
            element: <SellerToSellerDistributions />,
          },
          {
            path: "/distribuicoes-vendedor-para-unidade",
            element: <SellerToUnityDistributions />,
          },
          {
            path: "/distribuicoes-vendedor-para-unidade/historico",
            element: <SellerToUnityHistoryPage />,
          },
          {
            path: "/historico-distribuicoes",
            element: <DistributionHistory />,
          },
          {
            path: "/historico-acoes-distribuicao",
            element: <DistributionHistoryNew />,
          },
          {
            path: "/empresas",
            element: <Companies />,
          },
          {
            path: "/concursos",
            element: <ContestsPage />,
          },
          {
            path: "/lucros-concurso",
            element: <ContestProfitsPage />,
          },
          {
            path: "/tipos-de-descontos",
            element: <DiscountTypesPage />,
          },
          {
            path: "/categoria-de-clientes",
            element: <ClientsCategoriesPage />,
          },
          {
            path: "/vendedores",
            element: <SellersPage />,
          },
          {
            path: "/vendedores-historico",
            element: <SellersHistoricPage />,
          },
          {
            path: "/metas",
            element: <GoalsPage />,
          },
          {
            path: "/estoquistas",
            element: <StockistsPage />,
          },
          {
            path: "/produtos",
            element: <ProductsPage />,
          },
          {
            path: "/loterias",
            element: <LoteriasPage />,
          },
          {
            path: "/rotas",
            element: <RoutePage />,
          },
          {
            path: "/origens-de-clientes",
            element: <ClientOriginsPage />,
          },
          {
            path: "/categorias-de-despesas",
            element: <ExpenseCategoriesPage />,
          },
          {
            path: "/tipos-de-despesas",
            element: <ExpenseTypesPage />,
          },
          {
            path: "/contas-a-pagar",
            element: <FinancialTransactionsPage />,
          },
          {
            path: "/contas-bancarias",
            element: <BankAccountsPage />,
          },
          {
            path: "/operacoes-carteira",
            element: <WalletOperationsPage />,
          },
          {
            path: "/correcao-de-balancos",
            element: <BalanceAdjustmentsPage />,
          },
          {
            path: "/normalizacao-de-vendas",
            element: <SaleNormalizationPage />,
          },
          {
            path: "/rastreio-leads",
            element: <LeadTrackingPage />,
          },
          {
            path: "/unidades",
            children: [
              {
                path: "",
                element: <UnitsPage />,
              },
              {
                path: ":uuid_unit/usuarios",
                element: <UnitsUsersPage />,
              },
            ],
          },
          {
            path: "/cargos",
            children: [
              {
                path: "",
                element: <RolesPage />,
              },
              {
                path: "adicionar",
                element: <AddRolePage />,
              },
              {
                path: "editar/:uuid",
                element: <UpdateRolePage />,
              },
            ],
          },
          {
            path: "/crm/settings",
            element: <KanbanSettings />,
          },
          {
            path: "/premios-apuracao",
            element: <ContestInvestigationSummaryPage />,
          },
          {
            path: "/estabelecimentos",
            element: <EstablishmentsPage />,
          },
          {
            path: "/clientes",
            element: <ClientsPage />,
          },
          {
            path: "/usuarios",
            element: <UsersPage />,
          },
          {
            path: "/sobras",
            element: <LeftoversPage />,
          },
          {
            path: "/marketplace-vendas",
            element: <MarketplacePage />,
          },
          {
            path: "/devolucoes",
            element: <DevolutionsPage />,
          },
          {
            path: "/:tenant_uuid/usuarios",
            element: <UsersPage />,
          },
          {
            path: "/estoque",
            element: <StocksPage />,
          },
          {
            path: "/estoque-vendedores",
            element: <StocksSellersSummaryPage />,
          },
          {
            path: "/criar-venda",
            element: <SalesPage />,
          },
          {
            path: "/vendas",
            element: <SalesListPage />,
          },
          {
            path: "/sedex",
            element: <SedexPage />,
          },
          {
            path: "/solicitacoes-alteracao",
            element: <SaleChangeRequestsPage />,
          },
          {
            path: "/fila-pre-vendas",
            element: <PreSalesPage />,
          },
          {
            path: "/scripts-atendimento",
            element: <ServiceScriptsPage />,
          },
          {
            path: "/pix-gerados",
            element: <PaymentAdvancesPage />,
          },
          {
            path: "/vendas/comprovante/:id",
            element: <ReceiptView />,
          },
          {
            path: "/apuracao",
            element: <InvestigationSalesPage />,
          },
          {
            path: "/categorias-de-receitas",
            element: <RevenueCategoriesPage />,
          },
          {
            path: "/tipos-de-receitas",
            element: <RevenueTypesPage />,
          },
          // {
          //   path: "/notificacoes",
          //   element: <NotificationsPage />,
          // },
          {
            path: "/logs",
            element: <LogsPage />,
          },
          {
            path: "/acessar-como-usuario",
            element: <ImpersonationPage />,
          },
          {
            path: "/crm",
            element: <LeadsKanbanPage />,
          },
          {
            path: "/compras-de-clientes",
            element: <ClientPurchases />,
          },
          {
            path: "/crm/kanban",
            element: <LeadsKanbanPage />,
          },
          {
            path: "/crm/leads",
            element: <LeadsListPage />,
          },
          {
            path: "/configuracoes-de-comissao",
            element: <CommissionConfigPageList />,
          },
          {
            path: "/acompanhamentos-de-comissoes",
            element: <CommissionAccompanimentPageList />,
          },
          {
            path: "/faixas-de-comissao",
            element: <SellerCommissionRulesPage />,
          },
          {
            path: "/acompanhamentos-comissoes",
            element: <SellerCommissionTrackingPage />,
          },
          {
            path: "/reconciliacao-financeira",
            element: <ReconciliationFinancePage />,
          },
          {
            path: "/reconciliacao-financeira/:uuid",
            element: <ReconciliationFinanceView />,
          },
          {
            path: "/fluxo-de-caixa",
            element: <CashFlowPage />,
          },
          {
            path: "/relatorios",
            element: <ReportsPage />,
          },
          {
            path: "/configuracoes",
            element: <ConfigTenantPage />,
          },
          {
            path: "/*",
            element: <NotFound />,
          },
        ],
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/public/payment/:uuid",
        element: <PublicPaymentPage />,
      },
      {
        path: "/public/pix-gerado/:uuid",
        element: <PublicPaymentAdvancePage />,
      },
    ],
  },
]);
